/** Design System — Shadow tokens. Minimal, enterprise (no neumorphism). */
export const shadow = {
  none: 'none',
  xs: '0 1px 2px rgba(0, 0, 0, 0.04)',
  card: '0 2px 6px rgba(0, 0, 0, 0.06)',
  raised: '0 4px 12px rgba(0, 0, 0, 0.08)',
  modal: '0 8px 30px rgba(0, 0, 0, 0.12)',
  overlay: '0 16px 48px rgba(0, 0, 0, 0.18)',
} as const;

export type Shadow = typeof shadow;
